function AmazonPayoutHistoryCtrl($stateParams, AmazonPayoutHistoryService, CommonService, $state, toaster) {
  'ngInject';

  const vm = this;
  vm.loading = false;
  vm.orgId = $stateParams.orgId ? $stateParams.orgId : '';
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.syncLoading = false;
  vm.reportsInProgress = true;

  vm.init = function () {
    vm.loading = true;
    AmazonPayoutHistoryService.listPayoutHistory(vm.orgId, vm.pageNumber, vm.size, vm.sortBy, function (response) {
      vm.loading = false;
      if(response.status >=200 && response.status < 300){
        vm.response = response.data;
        vm.payoutReports = vm.response.amazon_payout_report;
        vm.currentPage = !vm.response.pagination ? 1 : vm.response.pagination.current_page;
        vm.totalPages = !vm.response.pagination ? 1 : vm.response.pagination.total_page;
        vm.reportsInProgress = vm.response.reports_inprogress;
      }
    });
  };

  vm.syncHistory = function(){
    vm.reportsInProgress = !vm.reportsInProgress;
    vm.syncLoading = true;
    AmazonPayoutHistoryService.goBackHistroy(vm.orgId, function (response) {
      vm.syncLoading = false;
      if(response.data.status == 'success'){
        toaster.pop('info', response.data.data);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.status = function(status){
    return status.split('_').join(' ');
  };

  vm.getStatusClass = function (status) {
    let label = '';
    switch (status) {
      case 'initial':
        label = 'label-primary';
        break;
      case 'running':
        label = 'label-warning';
        break;
      case 'done':
        label = 'label-success';
        break;
      case 'error':
        label = 'label-danger';
        break;
      case 'missing_mapping':
        label = 'label-danger';
        break;
      default:
    }
    return label;
  };

  vm.retryJob = function (reportInfo) {
    if(reportInfo.report_status != 'running'){
      AmazonPayoutHistoryService.retryJob(vm.orgId, reportInfo.id, function (response) {
        if(response.status >= 200 && response.status < 300){
          toaster.pop('info', response.data.message);
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };

  vm.paginate = function (param) {
    vm.url = vm.response.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.settingView.payoutHistory', { pageNumber: vm.pageNumber, size: vm.size });
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.response.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
    $state.go('user.organization.settingView.payoutHistory', { pageNumber: vm.pageNumber, size: vm.size });
  };

  vm.sortFlag = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        return false;
      }
    }
    return true;
  };

  vm.sort = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        param = '-' + param;
      }
    }
    $state.go('user.organization.settingView.payoutHistory', { sortBy: param });
  };

  vm.historyButton = function () {
    let buttonText = 'Go Back History';
    if(vm.reportsInProgress){
      buttonText = 'In Progress';
    }
    return buttonText;
  };
}

export default {
  name: 'AmazonPayoutHistoryCtrl',
  fn: AmazonPayoutHistoryCtrl
};